module.exports = __webpack_public_path__ + "media/images/homepage/user-13cd53fd7adf6e86f9a9e61cd0f73bf5.png";